/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import useDebounce from '@/utils/helper/useDebounce';
import { promoApi, subscriptionApi } from '@/api';
import { PromoList } from '@/types';
import { errorHandlingGlobal } from '@/utils/helper';
import {
  storeValidatePromoRes,
  initialState,
} from '@/store/commonDuck/promoDuck';
import store from '@/store';
import PromoView from './PromoView';

const PromoListComponent: React.FC<any> = props => {
  const location = useLocation<any>();
  const [promoLoading, setPromoLoading] = useState<boolean>(false);
  const [promoInput, setPromoInput] = useState<string>('');
  const [userTypeButNoPromo, setUserTypeButNoPromo] = useState<boolean>(false);
  const [promoResult, setPromoResult] = useState<Array<PromoList>>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const debouncedPromoInput = useDebounce(promoInput, 750);

  const alreadyPickPromo = location.state.promoCode
    ? location.state.promoCode.length > 0
    : false;
  const inputSameAsPickedPromo = promoInput === location.state.promoCode;

  const history = useHistory();
  const { search } = useLocation();

  const handlePromoInput = (value: any) => {
    setPromoLoading(true);
    setPromoInput(value);
  };

  const fetchPromoList = async (promoCode: string) => {
    try {
      const { data } = await promoApi.getPromoList(promoCode);
      if (data.length === 0) {
        setUserTypeButNoPromo(true);
        setPromoResult([]);
        return null;
      }
      setUserTypeButNoPromo(false);
      setPromoResult(data);
      return Promise.resolve(true);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const removePromo = async () => {
    try {
      await subscriptionApi.removePromo(location.state.subscriptionId);
    } catch (error) {
      errorHandlingGlobal(error);
    }
  };

  const fetchValidatePromo = async (promoCode: string, name: string) => {
    if (alreadyPickPromo && inputSameAsPickedPromo) {
      store.dispatch(storeValidatePromoRes(initialState.validatePromoRes));
      await removePromo();
      return Promise.resolve(true);
    }
    try {
      const { data } = await subscriptionApi.validatePromo(
        location.state.subscriptionId,
        { promo_code: promoCode }
      );
      store.dispatch(storeValidatePromoRes(data));
      return Promise.resolve(true);
    } catch (error) {
      errorHandlingGlobal(error, {
        '400': errorFromCallback => {
          store.dispatch(
            storeValidatePromoRes({
              ...initialState.validatePromoRes,
              name,
              promo_code: promoCode,
              errorCode: errorFromCallback.data.error_code,
            })
          );
        },
      });

      history.push({
        pathname: `/patient/order/${location.state.subscriptionId}`,
        search,
      });

      return Promise.reject(error);
    }
  };

  useEffect(() => {
    if (alreadyPickPromo) {
      setPromoInput(location.state.promoCode);
    }
  }, []);

  useEffect(() => {
    setPromoLoading(false);
    if (debouncedPromoInput) {
      fetchPromoList(debouncedPromoInput);
    }
    if (debouncedPromoInput === '') {
      setPromoResult([]);
      setUserTypeButNoPromo(false);
    }
  }, [debouncedPromoInput]);

  const onSelectPromo = async (data: PromoList) => {
    setLoading(true);
    await fetchValidatePromo(data.promo_code, data.name);
    history.push({
      pathname: `/patient/order/${location.state.subscriptionId}`,
      search,
    });
    history.location.state = {
      isChangeWalletState: false,
      origin: 'select/delete-promo',
    };
  };

  return (
    <PromoView
      location={location}
      promoLoading={promoLoading}
      promoInput={promoInput}
      handlePromoInput={handlePromoInput}
      promoResult={promoResult}
      alreadyPickPromo={alreadyPickPromo}
      inputSameAsPickedPromo={inputSameAsPickedPromo}
      userTypeButNoPromo={userTypeButNoPromo}
      onSelectPromo={onSelectPromo}
      setPromoInput={setPromoInput}
      loading={loading}
    />
  );
};

export default PromoListComponent;
